import React from "react";
import venus from "../image/venus.png";
import WSIW from "../image/WSIW.png";
import dribble from "../image/Dribbble.png";
export const Project = () => {
  return (
    <section id="project">
      <div className="projectabout">
        <h2 className="projectabout__h2">PROJECT</h2>
      </div>
      <div className="project">
        <div className="newProject">
          <div className="newProject__imgDiv">
            <img alt="dribble" src={dribble}></img>
          </div>
          <div className="newProject__content">
            <h3 className="">Starbucks APP</h3>
            <h3>使用者研究＆介面優化</h3>
            <p>
              透過問卷調查，研究星巴克APP使用者，了解他們的使用習慣、需求和期望，以及對APP功能和使用體驗的意見，從而進行星巴克APP的優化。
            </p>
            <div className="newProject__btnWarp">
              <a
                href="https://www.cakeresume.com/portfolios/project-5-cd1540"
                target="_blank"
                rel="noreferrer"
              >
                專案介紹
              </a>
            </div>
          </div>
        </div>
        <div className="project__container">
          <div className="project__warp">
            <img height="400px" alt="" src={WSIW}></img>
            <div className="project__content">
              <h3>Redesign</h3>
              <h4>WHAT SHOULD I WEAR?</h4>
              <p>
                此專案是和一位前端工程師協作，而我是負責UI設計。專案目的是為了讓您在每天決定穿什麼時......
              </p>
            </div>
            <div className="project__btnWarp">
              <a
                href="https://www.figma.com/exit?url=https%3A%2F%2Fwww.cakeresume.com%2Fportfolios%2Fwhat-should-i-wear"
                target="_blank"
                rel="noreferrer"
              >
                專案介紹
              </a>
              <a
                href="https://what-should-i-wear-bd38a.web.app/"
                target="_blank"
                rel="noreferrer"
              >
                網站連結
              </a>
            </div>
          </div>
          <div className="project__warp">
            <img height="400px" alt="" src={venus}></img>
            <div className="project__content">
              <h3>IOS APP Design </h3>
              <h4>VENUS</h4>
              <p>
                因為ＶENUS
                沒有實體店面，單靠Instagram銷售，所以決定創造一個官方網站，讓消費者方便選購。
              </p>
            </div>
            <div className="project__btnWarp">
              <a
                href="https://www.cakeresume.com/portfolios/ios-app-design-venus"
                target="_blank"
                rel="noreferrer"
              >
                專案介紹
              </a>
              <p>未上架</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
